module.exports = __webpack_public_path__ + "img/multiBlue.3bbacb12.jpg";